import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import HomeBanner1 from "../ones/HomeBanner1";

import Footer from "../ones/Footer";
import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';
import banner6 from '../assets/banner6.jpg';
import banner7 from '../assets/banner7.jpg';
import medical_pic from '../assets/photos/medical_equipments/18.jpg';
import promo_pic from '../assets/photos/promotional_materials/12.jpg';
import education_pic from '../assets/photos/educational_solutions/1.jpg';
import moble_pic from '../assets/photos/smart_mobile/2.jpg';
import realestate_pic from '../assets/photos/real_estate/3.jpg';
import telecom_pic from '../assets/photos/telecom_solutions/6.jpg';
import ict_pic from '../assets/photos/ict_solutions/1.jpg';
import agri_pic from '../assets/photos/agricultular_solutions/1.jpg';
import energ_pic from '../assets/photos/energy_solutions/1.jpg';
import green_pic from '../assets/photos/energy_solutions/3.jpg';

import ag1 from '../assets/photos/agricultular_solutions/1.jpg';
import ag2 from '../assets/photos/agricultular_solutions/2.jpg';
import ag3 from '../assets/photos/agricultular_solutions/3.jpg';
import ag4 from '../assets/photos/agricultular_solutions/4.jpg';
import ag5 from '../assets/photos/agricultular_solutions/5.jpg';
import ag6 from '../assets/photos/agricultular_solutions/6.jpg';

import ag11 from '../assets/photos/agricultular_solutions/11.jpeg';
import ag12 from '../assets/photos/agricultular_solutions/12.jpeg';
import ag13 from '../assets/photos/agricultular_solutions/13.jpeg';
import ag14 from '../assets/photos/agricultular_solutions/14.jpeg';
import ag15 from '../assets/photos/agricultular_solutions/15.jpeg';
import ag16 from '../assets/photos/agricultular_solutions/16.jpeg';
import ag17 from '../assets/photos/agricultular_solutions/17.jpeg';


import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaArrowCircleRight } from "react-icons/fa";
import HorizontalImageStrip from "../ones/HorizontalImagesStrip";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);
	const [ bgIndex, setBgIndex ] = useState(0);
	const banners = [banner5, banner7, banner1, banner2, banner3, banner4, ];

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [ ])

	// Background transition effect
	useEffect(() => {
		if (!ready) return;

		const interval = setInterval(() => {
			setBgIndex(prev => (prev + 1) % banners.length);
		}, 2500); // change every 5 seconds

		return () => clearInterval(interval);
	}, [ready]);

	if(ready) {
		return (
			<>
				<div className="MainBodySection">
					<div
						style={{
							width: "100%",
							height: "auto",
							position: "relative",
							overflow: "hidden"
						}}
					>
						{banners.map((banner, i) => (
							<div
								key={i}
								style={{
									backgroundImage: `url(${banner})`,
									backgroundAttachment: "fixed",
									backgroundSize: "cover",
									backgroundPosition: "center",
									width: "100%",
									height: "100%",
									position: "absolute",
									top: 0,
									left: 0,
									transition: "opacity 1.5s ease-in-out",
									opacity: i === bgIndex ? 1 : 0,
								}}
							/>
						))}
	
						{/* gradient overlay */}
						<div
							style={{
								width: "100%",
								height: "100%",
								background: "linear-gradient(to right, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.4) 80%, rgba(0,0,0,0) 100%)",
								position: "relative",
								zIndex: 1
							}}
						>
							<div className="container">
								<div className="row">
									<div className="col-md-6">
										<h1
											className="font-bold text-light"
											style={{
												fontSize: "28px",
												paddingTop: "40px",
												paddingBottom: "40px",
												textTransform: "uppercase",
											}}
										>
											AGRICULTURAL IMPLEMENTS SOLUTIONS
										</h1>
	
										
	
									</div>
	
									
	
								</div>
							</div>
						</div>
	
					</div>
				</div>
				
				<div 
					className="MainBodySection"
					style={{
						paddingBottom: "50px",
						paddingTop: "50px"
					}}
				>
					<div className="container">
						<div className="row">

							<div className="col-md-12">
								<img
									src={agri_pic}
									style={{
										width: "100%"
									}}
								/>
								<h6
									style={{
										fontSize: "18px",
										marginTop: "20px",
										marginBottom: "20px",
									}}
								>
									At JIEZHI TECH CO LTD, we provide agricultural implements and solution tools. Our wide range of products is customized to suit the specific requirements of farmers and agricultural experts. With a commitment to innovation and quality, we strive to offer cutting-edge solutions that enhance efficiency and productivity in the agricultural sector. Our team of dedicated professionals works tirelessly to ensure that our products are not only reliable but also environmentally friendly. Here are some of the items we offer:
								</h6>

								<HorizontalImageStrip
									images={[ag11, ag12, ag13, ag14, ag15]}
								/>
							</div>

							
							<div className="col-md-6 mt-3 mb-4">
								<h6 className="main-section-title">
									TRACTORS
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={ag2}
								/>	

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									At our company, we provide a wide selection of tractors designed to deliver reliable performance and exceptional versatility. From compact utility tractors to powerful row-crop tractors, our lineup includes models suited for various agricultural tasks, ensuring that farmers have the right equipment to maximize productivity in the field.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6 className="main-section-title">
									COMBINE HARVESTERS
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={ag11}
								/>	

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									Our combine harvesters are engineered to streamline the harvesting process and maximize crop yields. With advanced features and cutting-edge technology, our harvesters enable farmers to efficiently harvest a variety of crops while minimizing grain loss and optimizing throughput.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6 className="main-section-title">
									DISC HARROWS AND DISC PLOUGHS
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={ag6}
								/>	

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									We offer a range of disc harrows and disc ploughs designed to prepare the soil for planting and promote optimal seedbed conditions. Our equipment is built to withstand the rigors of field work and deliver consistent performance, ensuring that farmers can achieve optimal soil tillage and seedbed preparation.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6 className="main-section-title">
									SEED PROCESSING MACHINES
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={ag16}
								/>	

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									Seed quality is paramount for successful crop production. That’s why we provide seed processing machines designed to clean, sort, and treat seeds to ensure uniformity, purity, and germination. Our seed processing equipment helps farmers start their crops off on the right foot, leading to healthier plants and higher yields.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6 className="main-section-title">
									SEED PLANTERS
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={ag15}
								/>	

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									Precision planting is essential for optimizing crop emergence and maximizing yield potential. Our seed planters are equipped with advanced technologies and features to ensure accurate seed placement, spacing, and depth control, helping farmers achieve uniform stands and optimal crop performance.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6 className="main-section-title">
									OIL PROCESSING MACHINES
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={ag13}
								/>	

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									We offer oil processing machines, designed to extract oil from various oilseeds such as soybeans, sunflower seeds, and canola seeds. Our oil processing equipment is efficient, reliable, and easy to operate, enabling farmers and agribusinesses to produce high-quality edible oils for cooking and other applications.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6 className="main-section-title">
									RICE MILLING MACHINES
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={ag14}
								/>	

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									Rice is a staple food for millions of people worldwide, and our rice milling machines are designed to process rice efficiently and cost-effectively. From hulling and milling to polishing and grading, our rice milling equipment ensures that farmers can produce high-quality rice that meets market demand.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6 className="main-section-title">
									STORAGE FACILITIES EQUIPMENT
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={ag17}
								/>	

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									Proper storage is essential for preserving the quality and value of harvested crops. That’s why we provide a range of storage facilities equipment, including grain bins, silos, and storage bags, designed to protect crops from spoilage, pests, and moisture, ensuring that farmers can store their harvests safely and efficiently.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6 className="main-section-title">
									FOOD PROCESSING MACHINES
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={ag12}
								/>	

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									Our food processing machines are designed to add value to agricultural products by transforming raw materials into processed foods and ingredients. From mixing and grinding to packaging, our food processing equipment helps farmers and food processors create a wide range of products for domestic consumption and export.
								</h6>
							</div>

							
	
						</div>
					</div>
				</div>

				<Footer/>
			</>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}